import { HOLIDAY_REGIONS } from "@talentkontor/domain";
import { tr, type Lang } from "./sprache";

/**
 * Rundgang R-20 (Design-Prüfung, Inhaber 02.11.2026): Die 46 Feiertagskalender standen in einer langen, ungruppierten Liste.
 * Jetzt nach Land gruppiert (für optgroup): Deutschland, Österreich, Schweiz; zuerst die landesweiten Feiertage, danach Länder
 * bzw. Kantone alphabetisch in der Sprache der Oberfläche (im Englischen sonst „Bavaria“ zwischen B und H).
 */
export interface FeiertagsOption {
  key: string;
  label: string;
  /** Land als Gruppe; leer bei einer Region ohne bekanntes Land */
  group: string;
}

const LAENDER: readonly [code: string, name: (lang: Lang) => string][] = [
  ["DE", (l) => tr(l, "Deutschland", "Germany")], ["AT", (l) => tr(l, "Österreich", "Austria")], ["CH", (l) => tr(l, "Schweiz", "Switzerland")],
];

export function feiertagsOptionen(lang: Lang): FeiertagsOption[] {
  const en = lang === "en";
  const name = (r: { label: string; label_en: string }) => (en ? r.label_en : r.label);
  const out: FeiertagsOption[] = [];
  for (const [code, land] of LAENDER) {
    const alle = HOLIDAY_REGIONS.filter((r) => r.key.split("-")[0] === code);
    const teile = alle.filter((r) => r.key !== code).sort((a, b) => name(a).localeCompare(name(b), en ? "en" : "de"));
    for (const r of [...alle.filter((x) => x.key === code), ...teile]) out.push({ key: r.key, label: name(r), group: land(lang) });
  }
  // künftige Regionen ohne bekanntes Land gehen nicht verloren
  for (const r of HOLIDAY_REGIONS) if (!out.some((o) => o.key === r.key)) out.push({ key: r.key, label: name(r), group: "" });
  return out;
}

/** Optionen nach ihrer Gruppe bündeln (Reihenfolge bleibt), für <optgroup> */
export function nachGruppe<T extends { group?: string }>(options: readonly T[]): [group: string, options: T[]][] {
  const out: [string, T[]][] = [];
  for (const o of options) {
    const g = o.group ?? "";
    const last = out[out.length - 1];
    if (last && last[0] === g) last[1].push(o);
    else out.push([g, [o]]);
  }
  return out;
}
